import React from 'react'
import ListCustomerTableHead from "./ListCustomerTableHead"
import ListCustomerTableBody from "./ListCustomerTableBody"
import {Spin} from "antd"

function ListCustomerTable(props) {
    const {loading, error, listCustomers} = props

    return <div className="LeadTable">
        <Spin spinning={loading} tip="Đang lấy dữ liệu...">
            <table className="table">
                <ListCustomerTableHead/>
                <ListCustomerTableBody loading={loading} error={error} listCustomers={listCustomers}/>
            </table>
        </Spin>
    </div>
}

export default ListCustomerTable
